import { createContext } from 'react';

interface ShopItemContextProps {
    shopId: string;
    categoryId?: string;
}

const ShopItemContext = createContext<ShopItemContextProps>({} as ShopItemContextProps);

export default ShopItemContext;
